import React, { useEffect, useState } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Input,
  message,
  Table,
  Empty,
  Tooltip,
} from "antd";
import { useMediaQuery } from "react-responsive";
import "react-phone-input-2/lib/style.css";
import { PlusOutlined, CheckCircleOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import CurrencyInput from "react-currency-input";
import { odata } from "../Filters/Helper/index";
import { ColumnHelper } from "../../util/TableHelper";
const { TextArea } = Input;
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};

const StockMovementAddForm = (props) => {
  const [form] = Form.useForm();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const [loading, SetLoading] = useState(false);
  const [stockId, setStockId] = useState(props.stockId);
  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  const [projectSelectData, setProjectSelectData] = useState({
    data: [],
    loading: false,
  });
  const [visibleProjectSelect, setVisibleProjectSelect] = useState(false);
  const [stockMovementType, setStockMovementType] = useState();
  const [fromTransactionProjectTypeId, setFromTransactionProjectTypeId] =
    useState(null);
  const [toTransactionProjectTypeId, setToTransactionProjectTypeId] =
    useState(null);

  const [toProjectData, setToProjectData] = useState({
    data: [],
    loading: false,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
    RequestHandler.get(
      `/StockTransactionProjectType/GetListByStockId/${props.stockId}`
    ).then((res) => {
      setProjectSelect({
        data: res,
        loading: false,
      });
      setProjectSelectData({
        data: res,
        loading: false,
      });
    });

    RequestHandler.get(
      `/TransactionProjectType?$select=id,projectCode,name`
    ).then((res) => {
      setToProjectData({
        data: res.value,
        loading: false,
      });
    });

    RequestHandler.get(`/Firm?$select=id,firmBranchNumber,name`).then((res) => {
      setFirmSelect({ data: res.value, loading: false });
    });
  }, [props.data]);

  const onFinish = (values) => {
    if (
      values.fromTransactionProjectTypeId ===
        values.toTransactionProjectTypeId &&
      values.fromTransactionProjectTypeId !== null &&
      stockMovementType === 4
    ) {
      message.error("Çıkış ve Transfer Deposu aynı olamaz.");
      SetLoading(false);
      return;
    }
    values["stockId"] = stockId;
    RequestHandler.post(`/StockMovement`, values).then((response) => {
      SetLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinishFailed = () => {
    SetLoading(false);
  };

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      setProjectSelect({ data: [], loading: true });

      RequestHandler.get(
        `//StockTransactionProjectType/GetListByStockId/${
          props.stockId
        }$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setProjectSelect({ data: res, loading: false });
      });
    } else {
      setProjectSelect({ data: [], loading: false });
    }
  };

  const onToProjectSearch = (value) => {
    if (value.length >= 2) {
      setToProjectData({ data: [], loading: true });

      RequestHandler.get(
        `/TransactionProjectType$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setToProjectData({ data: res, loading: false });
      });
    } else {
      setToProjectData({ data: [], loading: false });
    }
  };

  useEffect(() => {
    if (form.getFieldValue("stockMovementType") === 4) {
      setVisibleProjectSelect(true);
    } else {
      setVisibleProjectSelect(false);
      form.setFieldsValue({
        fromTransactionProjectTypeId: null,
        toTransactionProjectTypeId: null,
      });
    }
  }, [stockMovementType]);

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Depo Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text, record) => {
        if (!text) return "";

        const shortText =
          text.length <= 50 ? text : text.substring(0, 50) + "...";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Tooltip title={text}>{shortText}</Tooltip>
            {record.isMain && (
              <Tooltip title="Ana Depo">
                <CheckCircleOutlined style={{ color: "green" }} />
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "Depo Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Adedi",
      dataIndex: "count",
      key: "count",
      align: "left",
      render: renderDecimal,
    },
  ];

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}) and Name ne 'Diğer'`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  return (
    <div>
      <Form
        {...layout}
        form={form}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          {isDesktopOrLaptop && (
            <>
              <Col span={20}>
                <Form.Item
                  label="Stok Adedi"
                  name="count"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Adedi giriniz.",
                    },
                  ]}
                >
                  <CurrencyInput
                    className="ant-input"
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    thousandSeparator="."
                    onChange={(value, name) => {
                      form.setFieldsValue({
                        count: name,
                      });
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="stockMovementType"
                  label="Stok Hareket Tipi"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Hareket Tipi'ni seçiniz..",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                    onChange={(value) => {
                      setStockMovementType(value);
                    }}
                  >
                    <Select.Option key={1} value={1}>
                      {"Stok Girişi"}
                    </Select.Option>
                    <Select.Option key={2} value={2}>
                      {"Stok Çıkışı"}
                    </Select.Option>
                    <Select.Option key={4} value={4}>
                      {"Depolar Arası Transfer"}
                    </Select.Option>
                  </Select>
                </Form.Item>

                {visibleProjectSelect && (
                  <Form.Item
                    name="fromTransactionProjectTypeId"
                    label="Çıkış Deposu :"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Çıkış Deposu'nu seçiniz.",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onProjectSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectSelect.loading}
                      onChange={(value) => {
                        setFromTransactionProjectTypeId(value);
                      }}
                    >
                      {projectSelect.data.map((item) => (
                        <Select.Option
                          key={item.transactionProjectTypeId}
                          value={item.transactionProjectTypeId}
                          code={item.projectCode}
                        >
                          {item.name + " (" + item.projectCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {visibleProjectSelect && (
                  <Form.Item
                    name="toTransactionProjectTypeId"
                    label="Transfer Deposu :"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Transfer Deposu'nu seçiniz.",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onProjectSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={toProjectData.loading}
                      onChange={(value) => {
                        setToTransactionProjectTypeId(value);
                      }}
                    >
                      {toProjectData.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.projectCode}
                        >
                          {item.name + " (" + item.projectCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                <Form.Item
                  name="firmId"
                  label="Proje :"
                  rules={[
                    { required: true, message: "Lütfen Proje'yi seçiniz." },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    placeholder="En az 2 harf giriniz.."
                    onSearch={onFirmSeach}
                    filterOption={(input, option) =>
                      option.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                      option.code
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                    loading={firmSelect.loading}
                  >
                    {firmSelect.data.map((item) => (
                      <Select.Option
                        key={item.id}
                        value={item.id}
                        code={item.firmBranchNumber}
                      >
                        {item.name + " ( " + item.firmBranchNumber + " ) "}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item label="Açıklama" name="description">
                  <TextArea rows={4} />
                </Form.Item>
              </Col>
              <Col span={4}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>

              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => SetLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
            </>
          )}
          {isTabletOrMobileDevice && (
            <>
              <Col span={24}>
                <Form.Item
                  label="Stok Adedi"
                  name="count"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Adedi giriniz.",
                    },
                  ]}
                >
                  <CurrencyInput
                    className="ant-input"
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    thousandSeparator="."
                    onChange={(value, name) => {
                      form.setFieldsValue({
                        count: name,
                      });
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="stockMovementType"
                  label="Stok Hareket Tipi"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Stok Hareket Tipi'ni seçiniz..",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                    onChange={(value) => {
                      setStockMovementType(value);
                    }}
                  >
                    <Select.Option key={1} value={1}>
                      {"Stok Girişi"}
                    </Select.Option>
                    <Select.Option key={2} value={2}>
                      {"Stok Çıkışı"}
                    </Select.Option>
                    <Select.Option key={4} value={4}>
                      {"Depolar Arası Transfer"}
                    </Select.Option>
                  </Select>
                </Form.Item>

                {visibleProjectSelect && (
                  <Form.Item
                    name="fromTransactionProjectTypeId"
                    label="Çıkış Deposu :"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Çıkış Deposu'nu seçiniz.",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onProjectSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={projectSelect.loading}
                      onChange={(value) => {
                        setFromTransactionProjectTypeId(value);
                      }}
                    >
                      {projectSelect.data.map((item) => (
                        <Select.Option
                          key={item.transactionProjectTypeId}
                          value={item.transactionProjectTypeId}
                          code={item.projectCode}
                        >
                          {item.name + " (" + item.projectCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {visibleProjectSelect && (
                  <Form.Item
                    name="toTransactionProjectTypeId"
                    label="Transfer Deposu :"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Transfer Deposu'nu seçiniz.",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onProjectSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={toProjectData.loading}
                      onChange={(value) => {
                        setToTransactionProjectTypeId(value);
                      }}
                    >
                      {toProjectData.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.projectCode}
                        >
                          {item.name + " (" + item.projectCode + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                <Form.Item label="Açıklama" name="description">
                  <TextArea rows={4} />
                </Form.Item>
              </Col>

              <Col span={12}></Col>
              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => SetLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>

              <Col span={6}></Col>
              <Col span={24}></Col>
              <Col span={24}></Col>
            </>
          )}
        </Row>
      </Form>

      <Table
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Veri Yok"
            />
          ),
        }}
        style={{
          overflowX: "auto",
          maxHeight: "100%",
          width: "100%",
        }}
        columns={columns}
        dataSource={projectSelectData.data}
        loading={projectSelectData.loading}
        pageable={true}
        sortable={true}
        rowKey="id"
      ></Table>
    </div>
  );
};
export default StockMovementAddForm;
